/* JungleSocks · Barra fija móvil con selector de talla · DS Performance · CMC 18102026
   Marcado: snippets/perf-sticky-atc.liquid (desde snippets/buy-buttons.liquid) · Estilos: assets/perf-sticky-atc.css
   - Las tallas de la barra solo «pulsan» las de la ficha (variant-radios): Dawn actualiza precio, URL e id del formulario.
     Una talla agotada abre el «Avísame» de assets/perf-back-in-stock.js, igual que en la ficha.
   - Sin talla elegida no se añade nada: se marcan las tallas con «Elige tu talla» (en la barra o en la ficha).
     Vale para el botón de la barra, el principal y el pago rápido (si se activa).
   - En móvil la barra solo aparece cuando el selector y el botón de la ficha no están en pantalla. */
(() => {
  const reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  const cssEscape = (s) => (window.CSS && CSS.escape ? CSS.escape(s) : String(s).replace(/["\\]/g, '\\$&'));

  function init(bar) {
    bar.setAttribute('data-pst-ready', '');
    const section = bar.dataset.section;
    const pf = bar.closest('product-form');
    const form = bar.closest('form');
    const picker = document.getElementById('variant-radios-' + section);
    const radios = picker ? [...picker.querySelectorAll('input[type="radio"]')] : [];
    const chips = [...bar.querySelectorAll('[data-pst-size]')];
    const add = bar.querySelector('[data-pst-add]');
    if (!pf || !form || !radios.length || !chips.length || !add) {
      bar.remove();
      return;
    }

    const fieldset = radios[0].closest('fieldset') || picker;
    const txtAdd = bar.querySelector('[data-pst-txt-add]');
    const txtNotify = bar.querySelector('[data-pst-txt-notify]');
    const price = bar.querySelector('[data-pst-price]');
    const msg = bar.querySelector('[data-pst-msg]');
    const mainBtn = document.getElementById('ProductSubmitButton-' + section) || form.querySelector('[name="add"]');
    const errWrap = pf.querySelector('.product-form__error-message-wrapper');
    const inModal = !!bar.closest('quick-add-modal, modal-dialog');
    const PICK = bar.dataset.tPick || '';
    let mainMsg = null;
    let msgTimer = 0;

    const current = () => radios.find((r) => r.checked) || null;
    const isOut = (r) => !!r && r.classList.contains('disabled');
    const radioFor = (v) => radios.find((r) => r.value === v);
    const labelFor = (r) => (r && r.id ? picker.querySelector('label[for="' + cssEscape(r.id) + '"]') : null);

    /* ---------- Estado ---------- */
    function setState() {
      const cur = current();
      let s = 'add';
      if (cur ? isOut(cur) : radios.every(isOut)) s = 'soldout';
      else if (mainBtn && mainBtn.classList.contains('loading')) s = 'loading';
      add.dataset.state = s;
      if (s === 'loading') add.setAttribute('aria-disabled', 'true');
      else add.removeAttribute('aria-disabled');
      if (txtAdd) txtAdd.hidden = s === 'soldout';
      if (txtNotify) txtNotify.hidden = s !== 'soldout';
    }

    function sync() {
      const cur = current();
      chips.forEach((chip) => {
        const r = radioFor(chip.dataset.value);
        const on = !!r && r === cur;
        chip.classList.toggle('is-active', on);
        chip.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (r) chip.classList.toggle('is-soldout', isOut(r));
      });
      if (cur) {
        const chip = chips.find((c) => c.dataset.value === cur.value);
        if (chip && price && chip.dataset.price) price.textContent = chip.dataset.price;
        clearPick();
      }
      pf.classList.toggle('pst-needs-size', !cur);
      setState();
      fit();
    }

    // Si «Añadir · precio» no cabe (pantallas muy estrechas, alemán…), se queda solo el verbo
    function fit() {
      if (!txtAdd || txtAdd.hidden) return;
      add.classList.remove('is-tight');
      if (txtAdd.scrollWidth > txtAdd.clientWidth + 1) add.classList.add('is-tight');
    }

    /* ---------- Avisos ---------- */
    function showMsg(text, kind) {
      if (!msg || !text) return;
      clearTimeout(msgTimer);
      msg.textContent = text;
      msg.dataset.kind = kind;
      msg.hidden = false;
      if (kind !== 'pick') msgTimer = setTimeout(() => { msg.hidden = true; }, 5000);
    }

    function pickInBar() {
      showMsg(PICK, 'pick');
      bar.classList.remove('is-alert');
      void bar.offsetWidth; // reinicia la animación
      bar.classList.add('is-alert');
    }

    function pickInPage() {
      fieldset.classList.add('pst-alert');
      if (!mainMsg) {
        mainMsg = document.createElement('p');
        mainMsg.className = 'pst-main-msg';
        mainMsg.setAttribute('role', 'alert');
        fieldset.insertAdjacentElement('afterend', mainMsg);
      }
      mainMsg.textContent = PICK;
      mainMsg.hidden = false;
      const r = fieldset.getBoundingClientRect();
      if (r.top < 72 || r.bottom > window.innerHeight - 24) {
        fieldset.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }

    function clearPick() {
      bar.classList.remove('is-alert');
      if (msg && msg.dataset.kind === 'pick') msg.hidden = true;
      fieldset.classList.remove('pst-alert');
      if (mainMsg) mainMsg.hidden = true;
    }

    // «Avísame»: simula el toque en la talla tachada de la ficha (lo recoge perf-back-in-stock.js)
    // sin activar la etiqueta, así no marca la talla ni desplaza la página.
    function notify(r) {
      const label = labelFor(r);
      if (!label) return;
      const stop = (e) => e.preventDefault();
      label.addEventListener('click', stop);
      label.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      label.removeEventListener('click', stop);
    }

    // Al elegir talla desde la barra, que la galería no suba la página si la variante tuviera foto propia
    function withoutMediaJump(fn) {
      let data = null;
      try { data = typeof picker.getVariantData === 'function' ? picker.getVariantData() : null; } catch (e) { data = null; }
      const saved = [];
      if (Array.isArray(data)) {
        data.forEach((v) => {
          if (v && v.featured_media) { saved.push([v, v.featured_media]); v.featured_media = null; }
        });
      }
      try { fn(); } finally { saved.forEach(([v, m]) => { v.featured_media = m; }); }
    }

    function pick(chip) {
      const r = radioFor(chip.dataset.value);
      if (!r) return;
      if (isOut(r)) { notify(r); return; }
      if (!r.checked) {
        withoutMediaJump(() => {
          r.checked = true;
          r.dispatchEvent(new Event('input', { bubbles: true }));
          r.dispatchEvent(new Event('change', { bubbles: true })); // variant-radios (Dawn) hace el resto
        });
      }
      sync();
    }

    /* ---------- Eventos ---------- */
    chips.forEach((chip) => chip.addEventListener('click', () => pick(chip)));

    add.addEventListener('click', (e) => {
      const s = add.dataset.state;
      if (s === 'loading') { e.preventDefault(); return; }
      if (s === 'soldout') {
        e.preventDefault();
        const cur = current();
        notify(isOut(cur) ? cur : radios.find(isOut));
        return;
      }
      if (!current()) { e.preventDefault(); pickInBar(); }
    });

    // Botón principal, Enter en la cantidad…: sin talla no se envía (va antes que product-form.js)
    pf.addEventListener('submit', (e) => {
      if (current()) return;
      e.preventDefault();
      e.stopPropagation();
      if (e.submitter && bar.contains(e.submitter)) pickInBar();
      else pickInPage();
    }, true);

    // Pago rápido (si se activa en la ficha): mismo aviso
    pf.querySelectorAll('[data-pst-dc]').forEach((guard) => {
      guard.addEventListener('click', (e) => {
        if (current()) return;
        e.preventDefault();
        e.stopPropagation();
        pickInPage();
      }, true);
    });

    picker.addEventListener('change', sync);
    if (mainBtn) new MutationObserver(setState).observe(mainBtn, { attributes: true, attributeFilter: ['class', 'disabled'] });
    if (errWrap) {
      new MutationObserver(() => {
        if (errWrap.hidden || !bar.classList.contains('is-on')) return;
        showMsg((errWrap.textContent || '').trim(), 'error');
      }).observe(errWrap, { attributes: true, attributeFilter: ['hidden'], childList: true, characterData: true, subtree: true });
    }
    if (document.querySelector('cart-drawer')) add.setAttribute('aria-haspopup', 'dialog');

    // Talla restaurada por el navegador (atrás/recarga) sin ?variant=: se resincroniza con Dawn
    const restored = current();
    if (restored && !restored.defaultChecked && !/[?&]variant=/.test(location.search)) {
      restored.dispatchEvent(new Event('change', { bubbles: true }));
    }
    sync();

    /* ---------- Visibilidad (móvil) ---------- */
    if (inModal) return;
    document.body.classList.add('pst-page');
    const setHeight = () => {
      const h = bar.offsetHeight;
      if (h) document.documentElement.style.setProperty('--pst-h', h + 'px');
    };
    setHeight();
    window.addEventListener('resize', () => { setHeight(); fit(); }, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);

    const show = (on) => {
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) bar.removeAttribute('inert');
      else bar.setAttribute('inert', '');
    };
    if (!('IntersectionObserver' in window)) { show(true); return; }
    const targets = [fieldset, mainBtn && (mainBtn.closest('.product-form__buttons') || mainBtn)].filter(Boolean);
    const seen = new Map();
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => seen.set(en.target, en.isIntersecting));
      show(![...seen.values()].some(Boolean));
    }, { rootMargin: '-64px 0px -96px 0px' });
    targets.forEach((t) => io.observe(t));
  }

  const scan = () => document.querySelectorAll('[data-pst]:not([data-pst-ready])').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
})();